import {gql} from '@apollo/client';

export default gql`
  mutation addMember($input: AddMemberInput!) {
    authed {
      success
    }
    addMember(input: $input) {
      organizationId
      membership {
        id
        role
        roleDisplay
        createdAt
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;
